export default __webpack_public_path__ + "static/media/rijul.83191d68.png";